import { Box, Text } from '@chakra-ui/react'

import {
  ATTRIBUTE_TAG_DATA,
  type LearnerFeedbackAttributeTag,
} from '@/client/services/learnerFeedback/constants'

import Icon from '@/components/UI/Icon/Icon'

export default function AttributeTag({ tagValue }: { tagValue: LearnerFeedbackAttributeTag }) {
  const tagData = ATTRIBUTE_TAG_DATA[tagValue]
  return (
    <Box
      key={tagValue}
      py="4px"
      pr="8px"
      pl="6px"
      textAlign="center"
      display="flex"
      alignItems="center"
      gap="4px"
    >
      <Icon color={tagData.color} faIcon={tagData.icon} size="lg" />
      <Text fontSize="14px" fontWeight={500}>
        {tagData.label}
      </Text>
    </Box>
  )
}
